import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { SitePreview } from '../../domain/entities/site';

export namespace GetAllSites {
  export const key = () => ['records', 'get-all-sites'];

  export type Params = { refetchInterval?: number; enabled?: boolean };
  export type Output = SitePreview[];

  export function useQuery({ refetchInterval, enabled = true }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      enabled,
      queryKey: key(),
      queryFn: () => repositories.site.getAll(),
    });
  }
}
